import { c as _c } from "react/compiler-runtime";
import type { DataIdentifier } from '@onefootprint/request-types/dashboard';
import { useFormContext } from 'react-hook-form';
import type { DecryptFormData } from '../decrypt-form.types';
const useDecryptForm = () => {
  const $ = _c(17);
  const form = useFormContext();
  let t0;
  if ($[0] !== form) {
    t0 = () => form.getValues("fields") || [];
    $[0] = form;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getFields = t0;
  let t1;
  if ($[2] !== form) {
    t1 = () => form.getValues("documentKinds") || [];
    $[2] = form;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getDocumentKinds = t1;
  let t2;
  if ($[4] !== form) {
    t2 = dis => {
      const currentFields = form.getValues("fields") || [];
      form.setValue("fields", [...currentFields, ...dis]);
    };
    $[4] = form;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const setFields = t2;
  let t3;
  if ($[6] !== form) {
    t3 = dis_0 => {
      const currentFields_0 = form.getValues("fields") || [];
      const filteredFields = currentFields_0.filter(field => !dis_0.includes(field));
      form.setValue("fields", filteredFields);
    };
    $[6] = form;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const unsetFields = t3;
  let t4;
  if ($[8] !== form) {
    t4 = di => {
      const fields = form.getValues("fields") || [];
      return fields.includes(di);
    };
    $[8] = form;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const isChecked = t4;
  let t5;
  if ($[10] !== form || $[11] !== getDocumentKinds || $[12] !== getFields || $[13] !== isChecked || $[14] !== setFields || $[15] !== unsetFields) {
    t5 = {
      setFields,
      unsetFields,
      isChecked,
      getFields,
      getDocumentKinds,
      ...form
    };
    $[10] = form;
    $[11] = getDocumentKinds;
    $[12] = getFields;
    $[13] = isChecked;
    $[14] = setFields;
    $[15] = unsetFields;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
export default useDecryptForm;